const AppDefaultValuesEnum = {
  LANGUAGE_ID: 1,
  LANGUAGE: 'en',
  PARTNER_ID: 4,
  GAME_ID: 141422,
  CURRENCY: 'USD',
  MODE: 'fun',
  APPLICATION_ID: 16,
};

Object.freeze(AppDefaultValuesEnum);

const AppConstantsEnum = {
  TOKEN: 'token',
  GAME_ID: 'gameid',
  GAME_TYPE_ID: 'gametypeid',
  EXIT_URL: 'exiturl',
  ACCESS: 'access',
  PARTNER_ID: 'partnerid',
  CURRENCY: 'currency',
  USER_ID: 'userid',
  MODE: 'mode',
  CURRENCY_SYMBOL: 'currencysymbol',
  CULTURE: 'culture', // Instead of LANGUAGE
  GAME_THEME: 'theme',
  REAL_MODE_SWITCHER: 'realmodeswitcher',
};

Object.freeze(AppConstantsEnum);

export { AppDefaultValuesEnum, AppConstantsEnum };
